import React, { useState, useRef, useEffect } from 'react';
import { Handle, NodeResizer } from 'reactflow';
import { Edit, Tag, Trash2 } from 'lucide-react';
import { NODE_MIN_WIDTH, NODE_MIN_HEIGHT } from '../constants';

const LabelNode = ({ data, id, selected }) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  const dispatchDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('deleteNode', { detail: { nodeId: id } }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        if (event.target.closest('button')?.textContent?.includes('⋮')) return;
        setShowMenu(false);
      }
    };

    if (showMenu) {
      const timeoutId = setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
      }, 100);
      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [showMenu]);

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <NodeResizer
        color="#6366f1"
        isVisible={selected}
        minWidth={NODE_MIN_WIDTH}
        minHeight={NODE_MIN_HEIGHT}
      />
      <Handle type="target" position="top" style={{ background: '#cbd5e0' }} />
      <Handle type="target" position="left" id="left-target" style={{ background: '#cbd5e0' }} />
      <div
        style={{
          background: 'white',
          borderRadius: '8px',
          border: selected ? '2px solid #6366f1' : '1px solid #e2e8f0',
          overflow: 'visible',
          cursor: 'pointer',
          position: 'relative',
          minWidth: '200px',
          width: '100%',
          height: '100%',
          boxSizing: 'border-box',
        }}
      >
        <div className="nodrag" style={{
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: '#f8fafc',
          borderBottom: '1px solid #e2e8f0',
          borderTopLeftRadius: '7px',
          borderTopRightRadius: '7px',
        }}>
          <div style={{
            width: '24px', height: '24px', borderRadius: '4px',
            background: '#6366f1', display: 'flex', alignItems: 'center',
            justifyContent: 'center', color: 'white',
          }}>
            <Tag size={14} />
          </div>
          <span style={{ fontWeight: '600', fontSize: '13px', color: '#1e293b', flex: 1, textTransform: 'uppercase', letterSpacing: '0.025em' }}>
            Description
          </span>
          <div className="nodrag" style={{ display: 'flex', alignItems: 'center', gap: '4px', pointerEvents: 'auto', position: 'relative', zIndex: 10 }}>
            <button
              type="button"
              className="nodrag"
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => { e.stopPropagation(); setShowMenu((p) => !p); }}
              style={{
                background: 'transparent', border: 'none', cursor: 'pointer',
                fontSize: '16px', color: '#94a3b8', padding: '4px 8px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >⋮</button>
            <button
              type="button"
              className="nodrag"
              onPointerDown={dispatchDelete}
              onMouseDown={dispatchDelete}
              onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
              style={{
                background: 'transparent', border: 'none', cursor: 'pointer',
                color: '#ef4444', padding: '4px', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                pointerEvents: 'auto', position: 'relative', zIndex: 10,
              }}
              title="Delete"
            >
              <Trash2 size={16} />
            </button>
          </div>
        </div>
        <div style={{ padding: '16px', fontSize: '14px', color: '#475569', fontWeight: '500' }}>
          {data.label}
        </div>
      </div>

      {showMenu && (
        <div ref={menuRef} style={{
          position: 'absolute', top: '45px', right: '-10px',
          background: 'white', border: '1px solid #e2e8f0',
          borderRadius: '8px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          zIndex: 1000, minWidth: '160px', padding: '4px',
        }}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setShowMenu(false);
              window.dispatchEvent(new CustomEvent('editNode', { detail: { nodeId: id } }));
            }}
            style={{
              width: '100%', padding: '8px 12px', background: 'transparent',
              border: 'none', cursor: 'pointer', fontSize: '13px', color: '#475569',
              display: 'flex', alignItems: 'center', gap: '8px', textAlign: 'left',
              borderRadius: '4px',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = '#f1f5f9')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            <Edit size={14} /> Edit Description
          </button>
        </div>
      )}

      <Handle type="source" position="bottom" style={{ background: '#cbd5e0' }} />
      <Handle type="source" position="right" id="right-source" style={{ background: '#cbd5e0' }} />
    </div>
  );
};

export default LabelNode;
